<div class="page-empty-header"></div>

<div class="container py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-xl-9">
      <h1 class="h3 mb-1">What's New</h1>
      <p class="text-muted mb-4">Recent updates to Agenda Master.</p>
      <app-whats-new-list></app-whats-new-list>
    </div>
  </div>
</div>
